import React from "react"
import "./sidebar.css"
import TabsRender from "../../module/tabs/Tabs"
const Sidebar = ({ isOpen }) => {
  return (
    <aside
      className={`sidebar ${isOpen ? "translate-x-0" : "-translate-x-full"} `}
    >
      <div className="side-container">
        <TabsRender />
      </div>
    </aside>
  )
}

export default Sidebar
